module.exports = __webpack_public_path__ + "static/media/FruitN'Nut Cookies 200g.fbb6fad3.jpg";